export default __webpack_public_path__ + "files/db2d7e134da4eb88e4c06772eb014385.svg";